import * as Dialog from '@radix-ui/react-dialog';
import styled from 'styled-components';

export const Header = styled.header`
  border-bottom: 0px solid var(--modal__border-color);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: var(--size-4) var(--size-5);
`;

export const Title = styled(Dialog.Title)`
  color: var(--modal__title-color);
  font-family: var(--modal-title__font-family);
  font-size: var(--modal-title__font-size);
  margin: 0;
  text-align: center;
`;

export const CloseButton = styled.button`
  appearance: none;
  background: none;
  border: 0;
  cursor: pointer;
  color: var(--modal__color);
  padding: 0;

  & svg {
    display: block;
  }
`;
